module.exports = {
  language: {
    name: '中文'
  },
  home: {
    name: '启高乐科技',
    newproduct: '新品上线',
    relationproduct: '相关产品'
  },
  header: {
    lang: '启高乐科技',
    logo: '启高乐科技',
    home: '首页',
    product: '产品',
    video: '视频',
    news: '新闻动态',
    about: '关于',
    search: '请输入产品关键字',
    searchsearch: "搜一搜",
    langageimg: 'en.png'
  },
  footer: {
    lang: 'English',
    home: '首页',
    product: '产品展示',
    video: '视频中心',
    news: '新闻动态',
    about: '关于启高乐',
    concact: '技术支持 海洋林风',
    power: '2022-2030 All Right Reserved ',
    address: '广东省汕头市启高乐科技实业有限公司',
    conputy: '汕头市启高乐科技实业有限公司 | 访问人数:'

  }
}



// WEBPACK FOOTER //
// ./src/language/zh.js